<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="dddark rounded mb-5 infocontainer" style="margin-top: -10px;"
           v-show="noDataAvailable">
      <v-col cols="12">
        <span class="d-block pb-1 text-h6 text-center">{{ $t('components.ReviewsDashboard.NoReviews') }}</span>
      </v-col>
    </v-row>

    <v-row align="start" justify="space-between" class="dddark rounded" style="margin-top: -10px;">
      <v-col cols="auto">
        <span class="d-block pb-1 text-h6">{{ $t('components.ReviewsDashboard.Title') }} {{ this.clinic }}</span>
      </v-col>
      <v-col cols="auto" v-if="!isMobile">
        <v-btn
            outlined
            elevation="0"
            @click="dowloadReport"
            :disabled="loading"
            style="margin-top: 1px; border-color: var(--v-ddgrey-base )">
          <v-icon color="ddgrey">mdi-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row id="reviews_report" class="ddblack">
      <v-col cols="12">
        <ReviewsPercentages :reviewsData="statistics" :loading="loading"/>
      </v-col>
      <v-col cols="12">
        <ReviewsStats :reviewsData="statistics.review_statistics" :loading="loading"/>
      </v-col>
      <v-col cols="12">
        <ReviewsByRating :reviewsData="statistics" :loading="loading"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import DataAPI from '@/utils/DataAPI';
import EventBus from '@/utils/EventBus';

import ReviewsPercentages from "@/components/dashboard/reviews/ReviewsPercentages.vue";
import ReviewsByRating from "@/components/dashboard/reviews/ReviewsByRating.vue";
import ReviewsStats from "@/components/dashboard/reviews/ReviewsStats.vue";

/**
 * This component includes all the features of Dashboard page such as change
 * between clinics, dates, download the report and show all other dashboard
 * widgets.
 *
 * To get data from the backend it uses the class DataAPI. To ensure that the
 * user is logged and check its capabilities it uses the class AuthAPI.
 */

export default {
  name: 'ReviewsDashboard',
  props: {
    initialClinic: {
      type: String,
      default: ""
    },
    ghlKey: {
      type: String,
      default: ""
    },
    accountId: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    loading: true,
    rawData: {},
    clinic: "",
    noDataAvailable: false,
    statistics: {
      total_reviews: 0,
      total_blocked_reviews: 0,
      total_reviews_replied_to: 0,
      total_qr_scans: 0,
      review_statistics: {
        by_month: {},
        by_month_accumulative: {},
        by_hour: {},
        by_day_of_week: {},
        by_rating: {}
      }
    },
    dateFilter: {
      from: false,
      to: false
    },
    isMobile: false
  }),
  watch: {
    ghlKey() {
      this.updateData(this.initialClinic, false, this.accountId);
    },
    accountId(newId) {
      this.updateData(this.initialClinic, false, newId);
    }
  },
  async mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
    await this.updateData(this.initialClinic, false, this.accountId);
  },
  methods: {
    noReviewsDataAvailable() {
      return this.statistics.total_reviews === 0
          && this.statistics.total_blocked_reviews === 0
          && this.statistics.total_reviews_replied_to === 0;
    },
    async updateData(clinic = false, location = false, accountId = "") {
      this.loading = true;

      const query = { clinic };
      if (location) query.location = location;
      if (accountId) query.accountId = accountId;

      this.statistics = await DataAPI.getReviewsData(query);
      this.clinic = this.statistics.clinic;
      if (this.noReviewsDataAvailable()) this.noDataAvailable = true;
      this.loading = false;
    },
    async dowloadReport() {
      EventBus.$emit("popup", "Downloading...");
      const reportElement = document.getElementById('reviews_report');
      const filename = `${this.clinic}_reviews_stats.pdf`;
      const canvas = await html2canvas(reportElement);
      const img = canvas.toDataURL('image/png');
      const doc = new jsPDF({
        unit: 'px',
        format: [canvas.width, canvas.height],
        hotfixes: ["px_scaling"]
      });

      doc.addImage(img, 'PNG', 0, 0);
      doc.save(filename);
    },
    onResize() {
      this.isMobile = window.innerWidth < 1000;
    }
  },
  components: {
    ReviewsStats,
    ReviewsByRating,
    ReviewsPercentages
  }
}
</script>
<style scoped>
.infocontainer {
  background-color: var(--v-ddlightblue-base) !important;
}

</style>